import img1 from '../Images/atf-1l.png'
import img2 from '../Images/atf-4l.png'
import img3 from '../Images/gear-oil.png'
import img4 from '../Images/heavy-duty-desiel-engine-oil-4l.png'
import img5 from '../Images/heavy-duty-desiel-engine-oil-5l.png'
import img6 from '../Images/heavy-duty-motor-engine-oil-25l.png'
import img7 from '../Images/manual-gear-oil-4l.png'
import img8 from '../Images/manual-gear-oil.png'
import img9 from '../Images/my-gold-suoer-no1-motor-oil-1l.png'
import img10 from '../Images/my-gold-suoer-no1-motor-oil-4l.png'
import img11 from '../Images/my-gold-suoer-no1-motor-oil-5l.png'
import img12 from '../Images/super-tonic-engine-oil-1l.png'
import img13 from '../Images/super-tonic-engine-oil-4l.png'
import img14 from '../Images/super-tonic-engine-oil-5l.png'
import oyoyo from '../Images/mygold.png'
import superTonic from '../Images/supertonic.png'
import heavy from '../Images/heavyduty.png'
import heavy25 from '../Images/heavyduty25.png'
import manual from '../Images/manual.png'
import atfmain from '../Images/atfmain.png'

const products = [
    {
      name: 'my gold super No 1 motor oil',
      id: 0,
      description: 'High-performance oil with UAE formula, designed for ultimate engine protection and efficiency.',
      longDesc: 'Oyoyo MY GOLD Super No. 1 is a high-performance engine oil designed with an SAE 50 viscosity rating, ideal for use in high-temperature environments. It meets API SJ/CF standards, making it perfect for older gasoline engines built before 2001 and indirect-injection diesel engines, ensuring superior protection against wear, oxidation, and deposits. Formulated with advanced technology from the UAE, this oil is engineered to enhance engine longevity and provide consistent, top-tier lubrication, even under extreme conditions. Available in convenient 5-liter, 4-liter, and 1-liter sizes, Oyoyo MY GOLD Super No. 1 is the ultimate choice for maintaining classic vehicles and heavy-duty machinery, ensuring optimal performance and efficiency across various applications.',
      images: [
        oyoyo,
        img11,
        img10,
        img9,
      ],
    },
    {
      name: 'Super Tonic MULTIGRADE',
      id: 1,
      description: 'High-quality engine oil, meeting API SF/CD standards, formulated in the UAE for enhanced engine protection.',
      longDesc: 'a wide range of temperatures. Its SAE 20W/50 viscosity ensures excellent flow at low temperatures while providing robust protection under high heat. Meeting API SF/CD standards, this oil is suitable for older gasoline and diesel engines, offering superior protection against wear, deposits, and sludge. The advanced UAE formulation further enhances engine longevity and efficiency. Available in convenient 5-liter, 4-liter, and 1-liter sizes, Super Tonic MULTIGRADE is the ideal choice for maintaining the performance and reliability of your vehicle under various driving conditions.',
      images: [
        superTonic,
        img14,
        img13,
        img12,
      ],
    },
    {
      name: 'Heavy Duty Diesel Engine Oil',
      id: 2,
      description: 'high-viscosity oil formulated for demanding applications where engines endure extreme conditions',
      longDesc: 'Heavy Duty Diesel Engine Oil SAE 50 is specially formulated for diesel engines operating under extreme conditions. This high-viscosity oil meets API SJ/CF standards, providing excellent protection against wear, deposits, and oxidation in older diesel engines. The advanced UAE-inspired formulation enhances engine durability, ensuring reliable performance even in harsh environments. This oil is available in 5-liter and 4-liter sizes, making it an ideal choice for heavy-duty applications where robust, long-lasting engine protection is essential. Keep your diesel engine running smoothly with this high-quality oil.',
      images: [
        heavy,
        img4,
        img5,
      ],
    },
    {
      name: 'ATF DEXRON III D',
      id: 3,
      description: 'versatile automatic transmission fluid, offering 2-in-1 super protection and performance with advanced formulation. Ideal for various vehicles.',
      longDesc: 'Oyoyo ATF DEXRON III D is a high-quality automatic transmission fluid designed to meet the rigorous demands of modern vehicles. It provides 2-in-1 super protection, ensuring smooth and efficient transmission operation while safeguarding critical components against wear and corrosion. The fluid is formulated to exceed the performance standards of DEXRON III D, offering excellent oxidation stability, friction durability, and low-temperature fluidity. Oyoyo ATF is ideal for use in automatic transmissions, power steering systems, and other hydraulic systems requiring DEXRON III D specifications. Available in various sizes, it ensures your vehicle’s transmission runs smoothly and reliably.',
      images: [
        atfmain,
        img1,
        img2,
        img3,
      ],
    },
    {
      name: 'heavy duty motor engine oil',
      id: 4,
      description: 'delivering superior protection and performance for both gasoline and diesel engines under extreme conditions.',
      longDesc: 'Heavy Duty Motor Engine Oil SAE 50 is a robust, high-viscosity lubricant designed for demanding applications in both gasoline and diesel engines. Compliant with API SJ/CF-4 standards, this oil offers excellent protection against wear, oxidation, and deposits, making it ideal for older engines operating under severe conditions. The SAE 50 rating ensures superior lubrication in high-temperature environments, providing reliable performance and enhancing engine longevity. Whether for heavy-duty vehicles or machinery, this oil is engineered to maintain engine efficiency and durability in even the harshest operational settings.',
      images: [
        heavy25,
        img6,
        
      ],
    },
    {
      name: 'SUPER STD ++ Manual Gear Oil',
      id: 5,
      description: 'delivers superior protection and performance for manual transmissions under extreme pressure conditions.',
      longDesc: 'SUPER STD ++ Manual Gear Oil EP140 is a premium-grade lubricant specifically designed for manual transmissions and differentials operating under high-pressure conditions. With an SAE 140 viscosity rating, this oil provides exceptional protection against wear, pitting, and corrosion, even in extreme temperatures and heavy-load situations. The API GL-4 certification ensures it meets the rigorous demands of gearboxes, offering smooth shifting and prolonged component life. The SUPER STD ++ formulation enhances lubrication efficiency, making it the ideal choice for maintaining the reliability and performance of manual transmissions in demanding environments.',
      images: [
        manual,
        img7,
        img8,
      ],
    },
  ];

export default products